export const responseDataPermissionUsingRole: any = {
    'cmrf_admin': {
        "user_locations": {
            "stateCodes": null,
            "districts": null
        },
        "user_role": [
            {
                "role_slug": "cmrf_admin"
            }
        ],
        "user_department": [],
        "user_type": [],
        "user_number": [],
        "user_role_permission": [
            {
                "uuid": "home123",
                "parent_id": "0",
                "name": "Home",
                "slug": "home",
                "module_url": "/admin/home",
                "icon": "HomeOutlined",
                "module_order": "1",
                "is_navigation": 1
            },
            {
                "uuid": "dashboard123",
                "parent_id": "0",
                "name": "Dashboard",
                "slug": "dashboard",
                "module_url": "/admin/dashboard",
                "icon": "DashboardOutlined",
                "module_order": "2",
                "is_navigation": 1
            },
            {
                "uuid": "quotation123",
                "parent_id": "0",
                "name": "Quotation",
                "slug": "quotation",
                "module_url": "/admin/quotation",
                "icon": "DescriptionOutlined",
                "module_order": "3",
                "is_navigation": 1
            },
            {
                "uuid": "proformainvoice123",
                "parent_id": "0",
                "name": "Proforma Invoice",
                "slug": "proforma-invoice",
                "module_url": "/admin/proforma-invoice",
                "icon": "ReceiptOutlined",
                "module_order": "4",
                "is_navigation": 1
            },
            {
                "uuid": "taxinvoice123",
                "parent_id": "0",
                "name": "Tax Invoice",
                "slug": "tax-invoice",
                "module_url": "/admin/tax-invoice",
                "icon": "RequestQuoteOutlined",
                "module_order": "5",
                "is_navigation": 1
            }
        ]
    }
}
